/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable camelcase */
// material
import Icon from '@iconify/react';
import Reviews from '@material-ui/icons/Reviews';
import DeleteIcon from '@material-ui/icons/Delete';
import {
	Box,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogTitle,
	FormControlLabel,
	IconButton,
	InputAdornment,
	Modal,
	Stack,
	Switch,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TablePagination,
	TableRow,
	TextField
} from '@material-ui/core';
import Clear from '@material-ui/icons/Clear';
import axios from 'axios';
import searchFill from '@iconify/icons-eva/search-fill';
import {useCallback, useEffect, useState} from 'react';
import {API_URL} from 'shared/constants';
// components
import axiosInstance from 'utils/axios';
import {useSnackbar} from 'notistack5';
import UserDetailForm from 'pages/dashboard/admin/UserDetailForm';
import Scrollbar from '../../../../../components/Scrollbar';
//
import SortingSelectingHead from './SortingSelectingHead';
import SortingSelectingToolbar from './SortingSelectingToolbar';

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

function getComparator(order, orderBy) {
	return order === 'desc'
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}
const styles = {
	position: 'absolute',
	bottom: '50%',
	height: '100%',
	display: 'block'
};
const style = {
	'&::-webkit-scrollbar': {
		display: 'none'
	},
	position: 'absolute',
	overflow: 'scroll',
	borderRadius: '25px',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 600,
	height: '100%',
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4
};
export default function SortingSelecting() {
	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('name');
	const [selected, setSelected] = useState([]);
	const [selectedID, setSelectedID] = useState([]);
	const [page, setPage] = useState(0);
	const [dense, setDense] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [data, setData] = useState([]);
	const [reloadList, setReloadList] = useState();
	const [dataNumber, setDataNumber] = useState();
	const [maxPage, setMaxPage] = useState();
	const [currentPage, setCurrentPage] = useState();
	const [searchInput, setSearchInput] = useState('');
	const [searchKey, setSearchKey] = useState('');
	const [openDialog, setOpenDialog] = useState(false);
	const handleOpenDialog = () => setOpenDialog(true);
	const handleCloseDialog = () => setOpenDialog(false);
	const {enqueueSnackbar} = useSnackbar();
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	// useEffect(() => {
	// 	const fetchData = async () => {
	// 		try {
	// 			await axios.get(`${API_URL.User}?page=${page + 1}&status=&search=${searchKey}`).then((res) => {
	// 				setData(res.data.users);
	// 				setMaxPage(res.maxPage);
	// 				setCurrentPage(res.currentPage);
	// 				if (res.maxPage > res.currentPage) {
	// 					// eslint-disable-next-line no-const-assign
	// 					setDataNumber(res.data.count);
	// 				} else {
	// 					setDataNumber(res.data.count);
	// 				}
	// 			});
	// 		} catch (error) {
	// 			setPage(page - 1);
	// 		}
	// 	};
	// 	fetchData();
	// }, [page, selectedID, reloadList]);
	useEffect(() => {
		const fetchData = async () => {
			try {
				await axiosInstance.get(`${API_URL.User}?page=${page + 1}&status=&search=${searchKey}`).then((res) => {
					setData(res.data.users);
					setMaxPage(res.maxPage);
					setCurrentPage(res.currentPage);
					if (res.maxPage > res.currentPage) {
						// eslint-disable-next-line no-const-assign
						setDataNumber(res.data.count);
					} else {
						setDataNumber(res.data.count);
					}
				});
			} catch (error) {
				setPage(page - 1);
			}
		};
		fetchData();
	}, [page, selectedID, searchKey, reloadList]);
	const deactivatedUser = useCallback(async (idSelected) => {
		try {
			console.log(idSelected);
			// eslint-disable-next-line no-restricted-globals, no-global-assign
			await axiosInstance
				.delete(`${API_URL.User}/${idSelected}`)
				.then((res) => {
					setSelectedID([]);
					enqueueSnackbar('Ngưng hoạt động tài khoản thành công', {variant: 'success'});
					setOpenDialog(false);
				})
				.catch((e) => {
					console.log(e.response.data.message);
					enqueueSnackbar('Không thể ngưng hoạt động tài khoản', {variant: 'error'});
				});
		} catch (e) {
			console.log(e);
			// enqueueSnackbar(e.data.message, {variant: 'error'});
			setOpenDialog(false);
		}
	}, []);
	useEffect(() => {
		setSelectedID([]);
	}, [reloadList]);
	const TABLE_HEAD = [
		{
			id: 'name',
			numeric: false,
			disablePadding: true,
			label: 'Tên'
		},
		{
			id: 'email',
			numeric: false,
			disablePadding: false,
			label: 'Email'
		},
		{
			id: 'role',
			numeric: false,
			disablePadding: false,
			label: 'Vai trò'
		},
		{
			id: 'status',
			numeric: false,
			disablePadding: false,
			label: 'Trạng thái'
		},
		{
			id: 'Lựa chọn',
			numeric: true,
			disablePadding: false,
			label: 'Thao tác'
		}
	];

	// ----------------------------------------------------------------------
	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const handleSelectAllClick = (event) => {
		setSelected([]);
		setSelectedID([]);
	};

	const handleClick = (event, data) => {
		console.log(data);
		const selectedIndex = selected.indexOf(data.email);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, data.email);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
		}

		const selectedIDIndex = selectedID.indexOf(data.id);
		let newSelectedID = [];

		if (selectedIDIndex === -1) {
			newSelectedID = newSelectedID.concat(selectedID, data.id);
		} else if (selectedIDIndex === 0) {
			newSelectedID = newSelectedID.concat(selectedID.slice(1));
		} else if (selectedIDIndex === selectedID.length - 1) {
			newSelectedID = newSelectedID.concat(selectedID.slice(0, -1));
		} else if (selectedIDIndex > 0) {
			newSelectedID = newSelectedID.concat(
				selectedID.slice(0, selectedIDIndex),
				selectedIDIndex.slice(selectedIDIndex + 1)
			);
		}
		setSelected(newSelected);
		setSelectedID(newSelectedID);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleChangeDense = (event) => {
		setDense(event.target.checked);
	};

	const isSelected = (name) => selected.indexOf(name) !== -1;

	// Avoid a layout jump when reaching the last page with empty data.
	const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

	return (
		<>
			{openDialog && (
				<Dialog
					open={openDialog}
					onClose={handleCloseDialog}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">Vô hiệu hóa tài khoản ?</DialogTitle>
					<DialogActions>
						<Button onClick={handleCloseDialog}>Hủy</Button>
						<Button onClick={() => deactivatedUser(selectedID)}>Đồng ý</Button>
					</DialogActions>
				</Dialog>
			)}
			{open && (
				<Modal
					sx={styles}
					// eslint-disable-next-line react/jsx-boolean-value
					open={true}
					onClose={handleClose}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<UserDetailForm userID={selectedID} onReload={setReloadList} onOpenModal={handleClose} />
					</Box>
				</Modal>
			)}
			<TextField
				fullWidth
				value={searchInput}
				placeholder="Tìm kiếm tài khoản..."
				sx={{
					'& fieldset': {
						borderRadius: '16px'
					}
				}}
				onChange={(e) => {
					setSearchInput(e.target.value);
				}}
				onKeyPress={(e) => {
					if (e.key === 'Enter') {
						setSearchKey(e.target.value);
						setPage(0);
					}
				}}
				InputProps={{
					startAdornment: (
						<>
							<InputAdornment position="start">
								<Box
									component={Icon}
									icon={searchFill}
									sx={{
										ml: 1,
										width: 20,
										height: 20,
										color: 'text.disabled'
									}}
								/>
							</InputAdornment>
						</>
					),
					endAdornment: (
						<IconButton
							sx={{visibility: searchInput ? 'visible' : 'hidden'}}
							onClick={() => {
								setSearchInput('');
								setSearchKey('');
								setPage(0);
							}}
						>
							<Clear />
						</IconButton>
					)
				}}
			/>
			<SortingSelectingToolbar
				numSelected={selected}
				idSelected={0}
				reloadData={setSelectedID}
				reloadNumber={setSelected}
				onReloadList={setReloadList}
			/>

			<Scrollbar>
				<TableContainer sx={{minWidth: 800}}>
					<Table size={dense ? 'small' : 'medium'} selectablerows="single">
						<SortingSelectingHead
							order={order}
							orderBy={orderBy}
							headLabel={TABLE_HEAD}
							numSelected={selected.length}
							onRequestSort={handleRequestSort}
							rowCount={data.length}
							onSelectAllClick={handleSelectAllClick}
						/>
						<TableBody>
							{stableSort(data, getComparator(order, orderBy)).map((row, index) => {
								const isItemSelected = isSelected(row.email);
								const labelId = `enhanced-table-checkbox-${index}`;

								return (
									<TableRow
										hover
										// onClick={(event) => handleClick(event, row)}
										role="checkbox"
										aria-checked={isItemSelected}
										tabIndex={-1}
										key={row.id}
									>
										{/* <TableCell padding="checkbox">
											<Checkbox checked={isItemSelected} />
										</TableCell> */}
										<TableCell
											onClick={(event) => {
												setSelectedID(row.id);
												handleOpen();
											}}
											component="th"
											id={labelId}
											scope="row"
											padding="none"
										>
											{row.name}
										</TableCell>
										<TableCell
											onClick={(event) => {
												setSelectedID(row.id);
												handleOpen();
											}}
											align="left"
										>
											{row.email}
										</TableCell>
										<TableCell
											onClick={(event) => {
												setSelectedID(row.id);
												handleOpen();
											}}
											align="left"
										>
											{row.role.description}
										</TableCell>
										<TableCell
											onClick={(event) => {
												setSelectedID(row.id);
												handleOpen();
											}}
											align="left"
										>
											{row.status === 'Verified' ? (
												<Button
													size="small"
													variant="contained"
													color="success"
													sx={{color: '#ffffff'}}
												>
													Đã xác thực
												</Button>
											) : row.status === 'Unverified' ? (
												<Button size="small" variant="outlined" color="success">
													<b>Chưa xác thực</b>
												</Button>
											) : row.status === 'Deactivated' ? (
												<Button
													size="small"
													variant="contained"
													color="error"
													sx={{color: '#ffffff'}}
												>
													<b>Vô hiệu hóa</b>
												</Button>
											) : (
												''
											)}
										</TableCell>
										<TableCell align="left">
											<Stack direction="row" spacing={1}>
												<IconButton
													onClick={() => {
														setSelectedID(row.id);
														handleOpenDialog();
													}}
												>
													<DeleteIcon color="error" />
												</IconButton>
											</Stack>
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</Scrollbar>

			<Box sx={{position: 'relative'}}>
				<TablePagination
					rowsPerPageOptions={[10]}
					component="div"
					count={dataNumber}
					rowsPerPage={10}
					page={currentPage - 1}
					onPageChange={handleChangePage}
				/>
			</Box>
		</>
	);
}
